import {Injectable} from '@angular/core';
import {ApiService} from '@abstract/api.service';
/**
 * Сервис формы профиля организации.
 */
@Injectable()
export class OrganizationRegistrationService extends ApiService {
    protected baseUrl = 'registration';
}
